import React, { useCallback, useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { useContent } from "../../../lib/content";
import { toast } from "sonner";
import { SECTIONS } from "./schema";
import { FieldInput } from "./fields";
import GalleryArchiveEditor from "./GalleryArchiveEditor";

function SectionForm({ section, all, onSaved }) {
  const [values, setValues] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    setValues(Object.fromEntries(section.fields.map(f => [f.key, all[f.key]])));
  }, [section, all]);

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/content", { values }); await onSaved(); toast.success("Salvato: le modifiche sono già online"); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore salvataggio"); }
    finally { setSaving(false); }
  };
  const reset = async () => {
    if (!window.confirm("Ripristinare i testi originali di questa sezione?")) return;
    await api.post("/admin/content/reset", { keys: section.fields.map(f => f.key) });
    await onSaved(); toast.success("Sezione ripristinata");
  };

  return (
    <div className="card-dark p-6 space-y-6" data-testid={`content-section-${section.id}`}>
      {section.fields.map(f => (
        <FieldInput key={f.key} field={f} value={values[f.key]} onChange={v => setValues(s => ({ ...s, [f.key]: v }))}/>
      ))}
      <div className="flex gap-3 pt-2">
        <button onClick={save} disabled={saving} className="btn-primary !py-2 !px-5 text-xs" data-testid="content-save">{saving ? "..." : "SALVA"}</button>
        <button onClick={reset} className="btn-ghost !py-2 !px-4 text-xs" data-testid="content-reset">RIPRISTINA ORIGINALI</button>
      </div>
    </div>
  );
}

export default function ContentPanel({ onChange }) {
  const [sid, setSid] = useState(SECTIONS[0].id);
  const [all, setAll] = useState(null);
  const { reload } = useContent();
  const loadAll = useCallback(() => api.get("/admin/content").then(r => setAll(r.data)), []);
  useEffect(() => { loadAll(); }, [loadAll]);
  const onSaved = async () => { await Promise.all([loadAll(), reload()]); onChange(); };
  const section = SECTIONS.find(s => s.id === sid);
  return (
    <div className="grid lg:grid-cols-[220px_1fr] gap-6">
      <div className="flex lg:flex-col gap-2 overflow-x-auto">
        {SECTIONS.map(s => (
          <button key={s.id} onClick={()=>setSid(s.id)} data-testid={`content-nav-${s.id}`}
            className={`text-left px-4 py-2 border font-mono text-[11px] tracking-widest whitespace-nowrap ${sid===s.id?"border-neon text-neon":"border-neutral-800 text-neutral-500 hover:text-white"}`}>
            {s.title}
          </button>
        ))}
      </div>
      {sid === "archive" ? <div className="card-dark p-6"><GalleryArchiveEditor/></div>
        : all ? <SectionForm section={section} all={all} onSaved={onSaved}/>
        : <div className="label-mono text-neutral-500 p-6">LOADING...</div>}
    </div>
  );
}
